import { render, staticRenderFns } from "./CategoriaDocentePage.vue?vue&type=template&id=74082c98"
import script from "./CategoriaDocentePage.js?vue&type=script&lang=js&external"
export * from "./CategoriaDocentePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports